var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChevronUpDown(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9,
    height: 14,
    viewBox: "0 0 9 14",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.25755 0L8.3607 4.10315C8.56644 4.30908 8.56638 4.64297 8.3607 4.84893C8.15476 5.05487 7.82024 5.05545 7.61423 4.84962L4.25686 1.49224L0.90017 4.84893C0.694162 5.05482 0.360357 5.05489 0.154393 4.84893C-0.0514644 4.64296 -0.0514644 4.30912 0.154393 4.10315L4.25755 0Z",
    fill: "currentColo"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.30546 13.9039L0.202311 9.80078C-0.00343378 9.59485 -0.00337499 9.26096 0.202311 9.055C0.408254 8.84906 0.742766 8.84848 0.948778 9.05431L4.30615 12.4117L7.66284 9.055C7.86885 8.84911 8.20265 8.84904 8.40862 9.055C8.61447 9.26097 8.61447 9.59481 8.40862 9.80078L4.30546 13.9039Z",
    fill: "currentColo"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronUpDown);
export default __webpack_public_path__ + "static/media/chevron-up-down.129a0db3057eb7b87462573ff2fff9e2.svg";
export { ForwardRef as ReactComponent };